import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const managerStore = {
  namespaced: true,
  state: {
    managerList: [],
    selectedManagerInfo: {
      account: '',
      email: '',
      department: '',
      note: '',
      name: '',
      phone: '',
      positionId: -1,
      positionName: '',
      servicePhone: '',
      serviceNumber: '',
    },
    backupManagerInfo: {
      account: '',
      email: '',
      department: '',
      note: '',
      name: '',
      phone: '',
      positionId: -1,
      positionName: '',
      servicePhone: '',
      serviceNumber: '',
    },
    /* 客訴管理的搜尋btn loading */
    isSearchBtnLoading: false,
    /* 客訴管理的搜尋表格 */
    searchForm: {
      teamCode: null,
      start: null,
      end: null,
      driverId: null,
      typeId: null,
      managerId: null,
      status: 0,
    },
    /* 目前登入後台的客服id */
    currentLoginServiceId: null,
    /* 客訴管理的司機資訊 */
    driverList: [],
    /* 客訴管理的客服種類 */
    typeList: [],
    /* 客訴管理的表格 */
    complainList: [],
    isTableLoading: false,
    paging: {
      currentPage: 1,
      nextPage: 2,
      previousPage: 0,
      totalPages: 1,
      perPage: 10,
    },
    /* 新增客訴單的dialog */
    isAddComplainDialog: false,
    /* 更新客訴單的dialog */
    updateComplainId: null,
    isUpdateComplainDialog: false,
    updateComplainDialog: {},
    /* 新增客訴事件的dialog */
    isAddEventDialog: false,
    /* 登入使用者的團隊角色權限 */
    teamRoles: [],
  },
  getters,
  mutations,
  actions,
}

export default managerStore



// WEBPACK FOOTER //
// ./src/store/managerStore/index.js